function refInit() {
    const bodyWrapper = document.querySelector('.main-container')
    if (bodyWrapper) {
        bodyWrapper.addEventListener('click', function (event) {
            if (event.target.hasAttribute('data-href')) {
                event.preventDefault()
                const refLink = event.target.dataset.href
                window.open(refLink, '_blank')
            }
        })
    }
}
export default refInit